import { useTranslation } from 'react-i18next';
import { CurrencyType, RefundAttemptDto } from '@tiendanube/common';
import { Domain } from '@tiendanube/common/src/enums';
import { DataList, Text } from '@tiendanube/components';
import { CurrencyPrice } from 'commons/components';

interface Attributes {
  currency: CurrencyType;
  refundAttempts: RefundAttemptDto[];
}

function OrderRefundAmountRow({
  refundAttempts,
  currency,
}: Readonly<Attributes>): JSX.Element | null {
  const { t } = useTranslation(Domain.ORDERS);
  const refundedAmount = refundAttempts
    .filter((a) => a.status.code === 'success')
    .reduce((sum, attempt) => sum + Number(attempt.refunded_amount.value), 0);

  if (refundedAmount === 0) {
    return null;
  }

  return (
    <DataList.Row id="refund_details">
      <DataList.Cell width={70}>
        <Text>{t('orderSummaryCard.tableAmounts.refundedAmount')}</Text>
      </DataList.Cell>
      <DataList.Cell width={30}>
        <CurrencyPrice
          appearance="danger"
          price={-refundedAmount}
          currency={currency}
          block
          textAlign="right"
        />
      </DataList.Cell>
    </DataList.Row>
  );
}
export default OrderRefundAmountRow;
